import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'normal-modal',
    templateUrl: './normal-modal.component.html',
    standalone: true
})
export class NormalModalComponent implements OnInit {
  configuration: any = this.dialogConfig.data;
  constructor(private dialogRef: DynamicDialogRef<NormalModalComponent>,
    private dialogConfig: DynamicDialogConfig) { }

  ngOnInit(): void {
  }

  handleDismiss() {
    this.dialogRef.close({result:'cancel'});
  }

  handleAccept() {
    this.dialogRef.close({
        result: 'ok'
    })
  }

}
